// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@sc/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@sc/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    CloseOverlay,
    RequestAccessToken,
    RequestSession,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import setSignInOverlayIsOpen from "@insite/client-framework/Store/Components/SignInOverlay/Handlers/SetSignInOverlayIsOpen";

export const _GaLogInEvent: typeof CloseOverlay = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (props.authenticatedSession) {
        props.dispatch(setSignInOverlayIsOpen({ isOpen: false }));
    }

    // XNG-Changes
    if (state.xGoogleAnalytics.loginEvent) {
        if (typeof window !== "undefined") {
            window.localStorage.setItem("pendingLoginEvent", "true");
        }
    }
};

const fireLoginIssueEvent = (state: xGoogleAnalyticsState) => {
    if (!state.xGoogleAnalytics.loginIssueEvent) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const googleAnalyticsData = {
        event: state.xGoogleAnalytics.loginIssueEventName,
        location: getLocation(state).pathname,
        affiliation: state.xGoogleAnalytics.affiliation,
        sales_rep: state.xGoogleAnalytics.salesRep || "",
        is_rep: state.xGoogleAnalytics.isRep || "",
        bill_to_num: state.xGoogleAnalytics.billToNum || "",
        ship_to_num: state.xGoogleAnalytics.shipToNum || "",
        cust_type: state.xGoogleAnalytics.customerType || "",
        login_type: state.xGoogleAnalytics.loginType || "",
        warehouse: state.xGoogleAnalytics.warehouse || "",
    };

    dataLayer.push({ ecommerce: null });
    dataLayer.push(googleAnalyticsData);
};

const _GaDispatchLoginIssueAfterToken: typeof RequestAccessToken = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    if (!props.tokenSuccessfullyRequested) {
        fireLoginIssueEvent(state);
    }
};

const _GaDispatchLoginIssueAfterSession: typeof RequestSession = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    if (props.tokenSuccessfullyRequested && !props.authenticatedSession) {
        fireLoginIssueEvent(state);
    }
};

addToChainAfter(chain, RequestAccessToken, _GaDispatchLoginIssueAfterToken);
addToChainAfter(chain, RequestSession, _GaDispatchLoginIssueAfterSession);
addToChainAfter(chain, CloseOverlay, _GaLogInEvent);
